<div class="modal fade app-popup-info" data-backdrop="static" id="app-model" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="cancel-btn">
                    <img src="assets/close-icon-gry.svg">
                </button>
                <div class="invite-friend-body">
                  <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
                    <div class="card-content">
                      <div class="card-header">
                        <h5 class="card-title">Title:</h5>
                        <input type="text" formControlName="title" id="title-input">
                      </div>
                      <!-- <div class="card-header">
                        <h5 class="card-title">App Code:</h5>
                        <input type="text" formControlName="appCode" id="title-input">
                      </div> -->
                      <div class="card-header">
                        <h5 class="card-title">Resources:</h5>
                          <ng-select 
                          [items]="resources_list"
                          bindLabel="content"
                          bindValue="id"
                          [multiple]="true"
                          [closeOnSelect]="false"
                          placeholder="Select Resource"
                          [(ngModel)]="selected_resources"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="getResourceId($event)">
                        </ng-select>
                      </div>
                      <div class="card-header">
                        <h5 class="card-title">App Tag:</h5>
                        <ng-select 
                          [items]="app_tags_list"
                          bindLabel="displayname"
                          bindValue="_id"
                          [closeOnSelect]="false"
                          placeholder="Select App Tag"
                          [(ngModel)]="selected_app_tag"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="getAppTagId($event)">
                        </ng-select>
                      </div>
                      <div class="card-header">
                        <h5 class="card-title">Description:</h5>
                        <textarea name="Content Scripts" id="textarea-input" formControlName="description" cols="30" rows="2"></textarea>
                      </div>
                      <div class="card-header">
                        <h5 class="card-title">Content Scripts:</h5>
                        <textarea name="Content Scripts" id="textarea-input" formControlName="content_scripts" cols="30" rows="2"></textarea>
                      </div>
                     
                      <div class="card-header">
                        <h5 class="card-title">Teachers Notes:</h5>
                        <textarea name="Teachers Notes" id="textarea-input" formControlName="teachers_notes" cols="30" rows="2"></textarea>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="mx-auto" *ngIf="appType=='text'">
                            <div id="full-wrapper">
                              <div id="full-container">
                                  <h4>
                                    Text App
                                  </h4><br>
                                  <h6>
                        The text app must in text format only. You can use other supporting tools like table, 
                        mathematical equeations, Bullets & numbering etc. from the text editor.
                        
                                  </h6>
                                <quill-editor [(ngModel)]="htmlText"
                                  [ngModelOptions]="{standalone: true}"
                                  (onEditorCreated)="setFocus($event)"></quill-editor>
                              </div>
                            </div>
                          </div>
                        
                          <div *ngIf="appType=='image'||appType=='video'" style="width: 100%;">
                           <h4>
                             <span *ngIf="appType=='video'"> Video app</span>
                             <span *ngIf="appType=='image'"> Image app</span>
                           </h4><br>
                           <h6>
                            <span *ngIf="appType=='video'"> Video app must be of '.mp4' or '.3gp' format</span>
                            <span *ngIf="appType=='image'"> Add Image of .gif, .jpg, .jpeg, or .png Format:</span>
                           </h6>
                            <img *ngIf="appType=='image'&&previewUrl" width="600px"
                              [src]="previewUrl" alt="Selected Image"><br/>
                              <div *ngIf="selectedFile">
                                <video *ngIf="appType=='video'&&previewUrl" width="600px" height="500px" [src]="previewUrl"
                                  controls></video>
                              </div>
                              <input type="file" #fileInput accept="{{appType}}/*"(change)="onFileSelected($event)">  <br>
                              <label>Or <span *ngIf="appType=='image'">Paste Image :</span><span
                                  *ngIf="appType=='video'">Paste Embeded Code :</span></label>
                              <input type="text" formControlName="url_link" id="url_link-input">
                              <div *ngIf="appType=='video'" class="mt-2">
                                <label>Or <span
                                    *ngIf="appType=='video'">Paste AWS S3 BUCKET URL:</span></label>
                                <input type="text" formControlName="aws_s3_file_url" id=" aws_s3_file_url-input">
                                </div>
                            </div>
                  
                          </div>
                        </div>
                        <div class="card-footer">
                          <button class="btn btn-primary" [disabled]="myForm.invalid" type="submit" id="submit-btn">Submit</button>
                          <button class="btn btn-secondary ml-2"  data-dismiss="modal" aria-label="Close"
                            id="cancel-btn">Cancel</button>
                        </div>
                      </div>
                      <!-- <div *ngIf="videoProgress>0"
                        class="text-center">
                        {{ FileProgessSize }} of {{ FileSize }}
                    </div> -->
                    <div class="popup-container"*ngIf="videoProgress > 0 && appType!='text'">
                      <div class="video-play-btn" >
                        <!-- <circle-progress [percent]="videoProgress" [radius]="50"
                            [outerStrokeWidth]="8" [innerStrokeWidth]="8"
                            [space]="-8" [outerStrokeColor]="'#53b2e8'"
                            [innerStrokeColor]="'#DCF3FF'" [animation]="false"
                            [animationDuration]="300"
                            subtitle="Uploading"></circle-progress> -->
                        <div *ngIf="videoProgress > 0" class="text-center">
                          {{ FileProgessSize }}-{{ FileSize }}
                        </div>
                      </div>
                    </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>



